import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "value", "defaultValue", "valueChange", "onChange", "showClearBtn", "clear", "error", "errMessage", "prefixText", "suffixText", "endAdornment", "placeholder", "formTitleDirection", "formTitle", "formTitleClassName", "formTitleSlot"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useState } from 'react';
import { Clear } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, TextField, Typography, styled } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { getLocalTranslation } from '../../utils/i18nKit';
import { JoveFormErrorInfoView } from '../form/JoveFormErrorInfoView';
import { JoveFormTitleDirectionEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StyleTextField = styled(TextField)({
  '& textarea:focus': {
    'box-shadow': 'none'
  },
  '& input:focus': {
    'box-shadow': 'none'
  },
  '& input': {
    fontWeight: 600
  },
  // The @tailwindcss/forms plugin base styles (`[type='text']`, `[type='email']`, ...) tie with MUI's
  // single-class selectors in specificity, so the effective input padding depends on stylesheet order
  // (in dev the Tailwind stylesheet is injected after the emotion ones, shrinking the field to ~39px).
  // Re-declare the MUI outlined input padding with higher specificity to keep the height consistent.
  '& .MuiOutlinedInput-input': {
    padding: '16.5px 14px',
    '&.MuiInputBase-inputSizeSmall': {
      padding: '8.5px 14px'
    },
    '&.MuiInputBase-inputMultiline': {
      padding: 0
    },
    '&.MuiInputBase-inputAdornedStart': {
      paddingLeft: 0
    },
    '&.MuiInputBase-inputAdornedEnd': {
      paddingRight: 0
    }
  }
});
var JoveTextField = /*#__PURE__*/forwardRef(function (props, ref) {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  var className = props.className,
      value = props.value,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      onChange = props.onChange,
      showClearBtn = props.showClearBtn,
      clear = props.clear,
      error = props.error,
      errMessage = props.errMessage,
      prefixText = props.prefixText,
      suffixText = props.suffixText,
      endAdornment = props.endAdornment,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? $t('text:please_input') : _props$placeholder,
      _props$formTitleDirec = props.formTitleDirection,
      formTitleDirection = _props$formTitleDirec === void 0 ? JoveFormTitleDirectionEnum.top : _props$formTitleDirec,
      formTitle = props.formTitle,
      formTitleClassName = props.formTitleClassName,
      formTitleSlot = props.formTitleSlot,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue || ''),
      inputValue = _useState[0],
      setInputValue = _useState[1];
  /**
   * methods
   */


  var inputChangeAction = function inputChangeAction(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    var tempValue = e.target.value;
    setInputValue(tempValue);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(tempValue, e);
  };
  /**
   * methods
   */


  var clearAction = function clearAction(e) {
    e.target.value = '';
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    setInputValue('');
    valueChange === null || valueChange === void 0 ? void 0 : valueChange('', e);
    clear === null || clear === void 0 ? void 0 : clear(e);
  };

  var getFormTitleComponent = function getFormTitleComponent(direction) {
    return formTitleSlot ? formTitleSlot : !!formTitle ? /*#__PURE__*/_jsx(Typography, {
      variant: "subtitle2",
      className: clsx('font-bold', formTitleClassName, direction === JoveFormTitleDirectionEnum.top ? 'mb-[2px]' : ''),
      style: {
        color: props !== null && props !== void 0 && props.disabled ? 'rgba(0, 0, 0, 0.38)' : undefined
      },
      children: formTitle
    }) : null;
  };

  var realValue = value === undefined ? inputValue : value || '';
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [formTitleDirection === JoveFormTitleDirectionEnum.top && getFormTitleComponent(formTitleDirection), /*#__PURE__*/_jsxs(Box, {
      className: "flex w-full flex-row items-center space-x-2",
      children: [formTitleDirection === JoveFormTitleDirectionEnum.left && getFormTitleComponent(formTitleDirection), /*#__PURE__*/_jsxs(Box, {
        className: "flex w-0 flex-1 flex-col",
        children: [/*#__PURE__*/_jsx(StyleTextField, _objectSpread(_objectSpread({}, rest), {}, {
          placeholder: placeholder,
          value: realValue,
          defaultValue: defaultValue,
          ref: ref,
          onChange: inputChangeAction,
          InputProps: {
            startAdornment: prefixText ? /*#__PURE__*/_jsx(InputAdornment, {
              position: "start",
              children: prefixText
            }) : null,
            endAdornment: suffixText ? /*#__PURE__*/_jsx(InputAdornment, {
              position: "end",
              children: suffixText
            }) : /*#__PURE__*/_jsxs(_Fragment, {
              children: [showClearBtn ? /*#__PURE__*/_jsx(InputAdornment, {
                position: "end",
                children: showClearBtn && Boolean(realValue) ? /*#__PURE__*/_jsx(IconButton, {
                  onClick: clearAction,
                  edge: "end",
                  children: /*#__PURE__*/_jsx(Clear, {})
                }) : null
              }) : null, endAdornment]
            })
          }
        })), /*#__PURE__*/_jsx(JoveFormErrorInfoView, {
          error: error,
          errMessage: errMessage
        })]
      })]
    })]
  });
});
export var JoveTextFieldControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error,
      field = _useController.field;

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveTextField, _objectSpread(_objectSpread(_objectSpread({}, rest), field), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      onChange: onChange,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveTextField;